import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ar from './locales/ar.json';

const storedLang = (localStorage.getItem('hm_language') as 'en' | 'ar') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: storedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    debug: true, // Enable debug mode to see what's happening
  });

export default i18n;



